import { jwtDecode } from "jwt-decode";

import config from "@/config";

/** Expected `iss` claim for tokens minted against the configured Auth0 domain. */
export function expectedIssuer(): string {
  return `https://${config.auth0Domain}/`;
}

/** True when the token was issued by a different Auth0 domain (e.g. after a custom-domain switch). */
export function isStaleIssuer(token?: string): boolean {
  if (!token) {
    return false;
  }
  try {
    const { iss } = jwtDecode<{ iss?: string }>(token);
    if (!iss) {
      return false;
    }
    return iss !== expectedIssuer();
  } catch {
    return false;
  }
}
